import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HashRouter, Route, Switch } from 'react-router-dom';

import Device from './route/Device';
import Login from './route/Login';
import Register from './route/Register';
import User from './route/User';
import BabyInfo from './route/BabyInfo';
import BindWeixin from './route/BindWeixin';
import MyGift from './route/MyGift';
import FM from './route/FM';
import ExchangeClass from './route/ExchangeClass';
import On from './route/On';
import { Utils } from '../src/utils/Utils';
import { CommonDialog } from './components/dialog/Dialog';
import utils from './lib/utils';
import { putaoWS } from './lib/ws';

import Index from './route/version-2/Index';
import LessonPath from './route/version-2/LessonPath';
// import Setting from './route/version-2/Setting';
import Setting from './route/version-2/Setting-2';
import Subject from './route/version-3/Subject';
import DeviceManagementPage from './route/version-3/DeviceManagementPage';
import SetPassword from './route/version-3/SetPassword';
// import Review from "./route/Review";

const PutaoID = Utils.getCookie('putaoid');
const UA = window.navigator.userAgent.toLocaleLowerCase();
window.isX5 = /tbs/.test(UA);
window.isApp = UA.indexOf('kidslearning_inapp_web') > -1 || UA.indexOf('kidslearning_vipbingo_web') > -1 ? true : false;
window.canSocket = window.isApp && UA.indexOf('1.0.0') === -1 ? true : false;
window.ffmpegDeniedRecord = false;   //是否拒绝录屏

window.isDev = Utils.getQueryString('code') && Utils.getHashQueryString('url') ? true : false;

class App extends Component {
    // 声明Context对象属性
    static childContextTypes = {
        user: PropTypes.object,
        getUser: PropTypes.func,
        clearUser: PropTypes.func,
    };

    // 返回Context对象，方法名是约定好的
    getChildContext() {
        const that = this;
        return {
            user: that.state.user,
            getUser: that.handleGetUser,
            clearUser: that.handleClearUser,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showTips: false,
            user: {},
            showCloseClient: false, // 客户端显示关闭按钮
        };

        this.appHashChangeHandler = this.appHashChangeHandler.bind(this);
        this.project = Utils.getHashQueryString("project") || "";
        this.appHashChangeHandler = this.appHashChangeHandler.bind(this);
    }

    componentWillMount() {
        const hash = window.location.hash;
        if (!PutaoID && hash.indexOf("#/review") === -1 && !window.isDev) {
            //回放不需要登录
            if (
                window.location.href.indexOf("login") < 0 &&
                window.location.href.indexOf("register") < 0
            ) {
                window.location.href = `${window.location.pathname}${window.location.search}#/login?url=${encodeURIComponent(window.location.href)}`;
            }
        }

        const favicon_icon = document.getElementById("favicon_icon");
        if (this.project === "vipbingo") {
            document.title = "VIP外教";
            favicon_icon && (favicon_icon.href = "https://www.aibingo.com.cn/bingo/vip_course/favicon.png");
        } else {
            document.title = "步步ABC";
            favicon_icon && (favicon_icon.href = "https://www.putaoabc.com/ai_course/favicon.png");
        }

        // 开启 webSocket 和 webServer
        putaoWS.startWebSocket(() => {
            putaoWS.createHttpServer();
        });

        // } else {
        //   if (window.location.pathname.indexOf("login") >= 0) {
        //     window.location.href = "/";
        //   }
        // }
        hash.indexOf("#/review") === -1 && !window.isDev && this.handleGetUser();

        window.addEventListener("hashchange", this.appHashChangeHandler, false);
    }

    componentDidMount() {
        this.appHashChangeHandler();

        window.onbeforeunload = () => {
            // 上课停止下载
            console.log('=====onbeforeunload=====')
            putaoWS.stopDownload();
            putaoWS.getDownloadStatus((status) => {
                console.log('是否下载中：', status)
            });
        }

        putaoWS.getOsInfo((content) => {
            this.setState({
                showCloseClient: content.showCloseClient || false
            });
            let isDenied = content.recordStatus && content.recordStatus === 'denied';   // 拒绝
            let isGranted = content.recordStatus && content.recordStatus === 'isGranted';   // 允许
            window.ffmpegDeniedRecord = isDenied;    //是否拒绝屏幕录制
            // isDenied && window.localStorage.setItem('recordStatus', '0');
            // isGranted && window.localStorage.setItem('recordStatus', '1');
        });

        window.LoadMtaJS && window.LoadMtaJS();
    }

    // 获取用户信息
    handleGetUser = (callback) => {
        const that = this;

        utils.getAppParams(params => {
            if (params) {
                that.setState({
                    user: params,
                }, () => {
                    if (callback && typeof callback === 'function') {
                        callback();
                    }

                    // 处理预加载视频
                    if (window.location.hash.indexOf("#/on") > -1 || window.location.hash.indexOf("#/review") > -1 || window.location.hash.indexOf("#/login") > -1) {
                        // 上课停止下载
                        putaoWS.stopDownload();
                        putaoWS.getDownloadStatus((status) => {
                            console.log('是否下载中：', status)
                        });
                    } else {
                        putaoWS.getAppDirname((content) => {
                            console.log(JSON.stringify(content))
                        });

                        // putaoWS.getVideoIsExist("https://cres.putaoabc.com/level300/unit11/lesson1/1569588089/video/L1-1_s.mp4", (isExist) => {
                        //     alert(isExist)
                        // });

                        // 获取需要下载的视频列表
                        Utils.getNeedDownloadVideoList(Object.assign({ "needPreview": 1 }, params), (lessons) => {
                            // lessons = [{ "cid": "300_11_1", "videoListUrl": "https://courses-1256571289.cos.ap-beijing.myqcloud.com/level300/unit11/lesson1/1569588089/videolist.json", "title": "On Your Nose!", "version": "1569588089", "resourceVersion": 4, "resourceUrl": "https://cres.putaoabc.com/level300/unit11/lesson1/1569588089/resource.zip", "previewVideoUrl": "https://cres.putaoabc.com/previewVideo/300_11_1.mp4" }];
                            putaoWS.startDownload(lessons, (content) => {
                                console.log('auto: ' + content.cid + ": " + content.progress + "/100");
                            });
                            // putaoWS.getDownloadStatus((status) => {
                            //     console.log('是否下载中：', status)
                            // });
                        });
                    }

                });
            }
        }, {}, window.publicUrl);
    };

    // 点击退出，请求用户信息
    handleClearUser = () => {
        this.setState({ user: null })
    }

    appHashChangeHandler() {
        Utils.testIs360();

        if (window.location.href.indexOf('login') === -1 && window.location.href.indexOf('review') === -1 && !window.isX5 && !window.isDev) {
            this.setState({
                showTips: UA.indexOf('chrome') > -1 && UA.split(' ')[UA.split(' ').length - 1].indexOf('safari') > -1 && !Utils.testIs360() ? false : true,
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('hashchange', this.appHashChangeHandler);
    }

    downloadHandler() {
        window.open('https://www.google.cn/chrome/');
        // if (/(macintosh).*(mac os x)/i.test(UA)) {
        //   window.open(
        //     "https://download-1256571289.cos.ap-beijing.myqcloud.com/Chrome/googlechrome.dmg"
        //   );
        // }
        // if (UA.indexOf("win64") > -1 || UA.indexOf("wow64") > -1) {
        //   window.open(
        //     "https://download-1256571289.cos.ap-beijing.myqcloud.com/Chrome/ChromeStandaloneSetup.exe"
        //   );
        // }
        // if (UA.indexOf("win32") > -1 || UA.indexOf("wow32") > -1 || Utils.testIs360()) {
        //   window.open(
        //     "https://download-1256571289.cos.ap-beijing.myqcloud.com/Chrome/ChromeStandaloneSetup.exe"
        //   );
        // }

        // if (UA.indexOf('mac') >= 0) {
        //     window.open('https://download.putaoabc.com/pc/mac/putaoABC.dmg');
        // } else if (UA.indexOf('win64') >= 0 || UA.indexOf('wow64') >= 0) {
        //     window.open('https://download.putaoabc.com/pc/win/putaoABC-win64.exe');
        // } else {
        //     window.open('https://download.putaoabc.com/pc/win/putaoABC-win32.exe');
        // }
    }

    closeClient() {
        putaoWS.closeClient();
    }

    render() {
        const { showTips, showCloseClient } = this.state;
        return (
            <HashRouter>
                <div className='App'>
                    {
                        showCloseClient ?
                            <div className='close-client' title='关闭' onClick={() => this.closeClient()}><span className='close-icon' /></div>
                            : null
                    }
                    <Switch>
                        <Route exact path='/' component={Index} />
                        <Route path='/device' component={Device} />
                        <Route path='/login' component={Login} />
                        <Route path='/register' component={Register} />
                        <Route path='/user' component={User} />
                        <Route path='/path' component={LessonPath} />
                        <Route path='/baby-info' component={BabyInfo} />
                        <Route path='/bind-weixin' component={BindWeixin} />
                        <Route path='/my-gift' component={MyGift} />
                        <Route path='/FM' component={FM} />
                        <Route path='/setting' component={Setting} />
                        <Route path='/exchange-class' component={ExchangeClass} />
                        <Route path='/on' component={On} />
                        <Route path='/subject' component={Subject} />
                        <Route path='/device-management' component={DeviceManagementPage} />
                        <Route path='/set-password' component={SetPassword} />

                        {/* <Route path="/review" component={Review} /> */}
                    </Switch>
                    {showTips && (
                        <CommonDialog
                            title='温馨提醒'
                            text='为保证最佳学习效果，请使用谷歌Chrome浏览器学习~'
                            hasClose={false}
                            cancleText='知道了'
                            cancleHandler={() => {
                                this.setState({ showTips: false });
                            }}
                            sureText='立即下载'
                            sureHanlder={() => {
                                this.downloadHandler();
                            }}
                        />
                    )}
                </div>
            </HashRouter>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js